import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-update-hospital',
  templateUrl: './update-hospital.component.html',
  styleUrls: ['./update-hospital.component.css']
})
export class UpdateHospitalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
